import Spinner from '@/common/components/Spinner'
import { Button } from '@/common/ui/button'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '@/common/ui/dialog'
import { Separator } from '@/common/ui/separator'
import useQueryGetDailyCheckInById from '@/modules/promotion/api/hooks/useQueryGetDailyCheckInById'
import { Eye, PencilIcon } from 'lucide-react'
import { useState } from 'react'
import { Link } from 'react-router-dom'
import useQueryProfile from '@/modules/auth/api/hooks/useQueryProfile'
import { PermissionKeys } from '@/modules/manage-member/mappers'

interface DailyCheckInModalProps {
	id: string
}

export default function DailyCheckInModal({ id }: DailyCheckInModalProps) {
	const { data: user } = useQueryProfile()
	const hasWritePermission = user?.userGroup.writePermission.includes(
		PermissionKeys.MANAGE_DAILY_CHECK_IN,
	)

	const [open, setOpen] = useState(false)
	const { data: dailyCheckIn, isLoading } = useQueryGetDailyCheckInById(id)

	return (
		<>
			<Button variant="ghost" size="icon" onClick={() => setOpen(true)}>
				<Eye className="h-4 w-4" />
			</Button>

			<Dialog open={open} onOpenChange={setOpen}>
				<DialogContent className="max-h-[90vh] overflow-y-auto sm:max-w-[600px]">
					<DialogHeader>
						<DialogTitle>รายละเอียดเช็คอินรายวัน</DialogTitle>
					</DialogHeader>

					{isLoading ? (
						<div className="flex items-center justify-center">
							<Spinner />
						</div>
					) : dailyCheckIn ? (
						<div className="space-y-4">
							<div className="flex justify-between">
								<div>
									<h3 className="font-semibold">ชื่อ</h3>
									<p>{dailyCheckIn.name}</p>
								</div>
								{hasWritePermission && (
									<Button variant="outline" size="icon">
										<Link to={`/operator/daily-check-in/${id}`}>
											<PencilIcon className="h-4 w-4" />
										</Link>
									</Button>
								)}
							</div>

							<Separator />

							<div>
								<h3 className="font-semibold">จำนวนวัน</h3>
								<p>{dailyCheckIn.days} วัน</p>
							</div>

							<div>
								<h3 className="font-semibold">รอบเทิร์น</h3>
								<p>{dailyCheckIn.turnoverRound}</p>
							</div>

							<Separator />

							<div>
								<h3 className="mb-4 font-semibold">รายละเอียดรางวัล</h3>
								<div className="grid grid-cols-3 gap-4">
									{dailyCheckIn.checkInSetting.map((setting) => (
										<div
											key={setting.id}
											className="space-y-2 rounded-lg border p-3"
										>
											<p className="font-medium">วันที่ {setting.day}</p>
											<p>รางวัล: {setting.amount} เครดิต</p>
										</div>
									))}
								</div>
							</div>

							<div className="flex justify-end gap-4 pt-4">
								<Button variant="outline" onClick={() => setOpen(false)}>
									ปิด
								</Button>
							</div>
						</div>
					) : null}
				</DialogContent>
			</Dialog>
		</>
	)
}
